import { render, staticRenderFns } from "./Verified.vue?vue&type=template&id=2544e6b8&scoped=true"
import script from "./Verified.vue?vue&type=script&lang=js"
export * from "./Verified.vue?vue&type=script&lang=js"
import style0 from "./Verified.vue?vue&type=style&index=0&id=2544e6b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544e6b8",
  null
  
)

export default component.exports